import { Meteor } from 'meteor/meteor';

import { Projets } from '../../imports/collections.js';

export function normaliseSharedProjectIds (pProjectIds, pFallbackProjectId = null)
  {
    const tIds = [];
    const tAjoute = (pValue) =>
      {
        if (typeof pValue !== 'string') return;
        const tValue = pValue.trim ();
        if (!tValue || tIds.includes (tValue)) return;
        tIds.push (tValue);
      };

    if (Array.isArray (pProjectIds))
      for (const tProjectId of pProjectIds) tAjoute (tProjectId);

    tAjoute (pFallbackProjectId);
    return tIds;
  }

export function sharedProjectIdsForDocument (pDoc, pFallbackProjectId = null)
  {
    if (pDoc && Array.isArray (pDoc.shared_project_ids))
      return normaliseSharedProjectIds (pDoc.shared_project_ids, null);
    if (pDoc
        && Object.prototype.hasOwnProperty.call (pDoc, 'shared_project_ids')
        && pDoc.shared_project_ids === null)
      return normaliseSharedProjectIds ([], pDoc.projet_id || pFallbackProjectId);
    if (pDoc && typeof pDoc.projet_id === 'string' && pDoc.projet_id)
      return normaliseSharedProjectIds ([pDoc.projet_id], null);
    return normaliseSharedProjectIds ([], pFallbackProjectId);
  }

function ids_contacts_courants ()
  {
    const tUserId = Meteor.userId ();
    if (!tUserId) return [];
    const tUser = Meteor.users.findOne (tUserId);
    return Array.isArray (tUser && tUser.contacts) ? tUser.contacts : [];
  }

function libelle_proprietaire_projet (pProjet)
  {
    if (!pProjet || !pProjet.user_id) return 'Contact';
    const tUser = Meteor.users.findOne (pProjet.user_id);
    if (!tUser) return 'Contact';
    return (tUser.profile && tUser.profile.name)
      || tUser.username
      || tUser.slug
      || 'Contact';
  }

export function buildSharingPickerData ({selectedIds = null, defaultProjectId = null} = {})
  {
    const tSelectedIds = selectedIds === null
      ? normaliseSharedProjectIds ([], defaultProjectId)
      : normaliseSharedProjectIds (selectedIds, null);
    const tUserId = Meteor.userId ();
    const tContactIds = ids_contacts_courants ();
    const tProjets = Projets.find ({}, {sort : {date_creation : -1}}).fetch ();
    const tMesProjetsIds = new Set ();
    const tMappe = (pProjet) =>
      ({
        ...pProjet,
        checkedAttr : tSelectedIds.includes (pProjet._id) ? 'checked' : null,
        ownerLabel  : libelle_proprietaire_projet (pProjet),
      });

    const tMesProjets = tProjets
      .filter ((pProjet) =>
        pProjet
        && (
          pProjet.user_id === tUserId
          || (Array.isArray (pProjet.membres) && pProjet.membres.includes (tUserId))
          || (Array.isArray (pProjet.admins) && pProjet.admins.includes (tUserId))
        ))
      .map ((pProjet) =>
        {
          tMesProjetsIds.add (pProjet._id);
          return tMappe (pProjet);
        });

    return {
      myProjects : tMesProjets,
      contactProjects : tProjets
        .filter ((pProjet) =>
          pProjet
          && !tMesProjetsIds.has (pProjet._id)
          && pProjet.user_id !== tUserId
          && tContactIds.includes (pProjet.user_id))
        .map (tMappe),
    };
  }

export function collectCheckedProjectIds (pRoot, pSelector)
  {
    if (!pRoot || typeof pRoot.querySelectorAll !== 'function') return [];
    const tSelector = (typeof pSelector === 'string' && pSelector.trim ())
      ? pSelector.trim ()
      : '[data-sharing-project-id]';
    let tInputs = [...pRoot.querySelectorAll (tSelector)];
    if (!tInputs.length && tSelector !== '[data-sharing-project-id]')
      tInputs = [...pRoot.querySelectorAll ('[data-sharing-project-id]')];
    const tIds = [];
    tInputs.forEach ((pInput) =>
      {
        if (!pInput || !pInput.checked) return;
        const tValue = typeof pInput.value === 'string' && pInput.value.trim ()
          ? pInput.value.trim ()
          : (typeof pInput.dataset.sharingProjectId === 'string'
            ? pInput.dataset.sharingProjectId.trim ()
            : '');
        if (!tValue || tIds.includes (tValue)) return;
        tIds.push (tValue);
      });
    return tIds;
  }